var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, html, LitElement, property } from 'lit-element';
import { Codellaborate } from '../codellaborate/Codellaborate';
let ChatElement = class ChatElement extends LitElement {
    constructor() {
        super(...arguments);
        this.name = 'World';
        this.currentMessage = '';
        this.profileId = Math.random() + '';
        this.receivedMessages = [];
    }
    render() {
        return html `
        <style>
           
           .communication-chat__header {
                background-color: #CDCDCD;
                width: 100%;
                flex: 0 0 20px;
                cursor: pointer;
           }
           
           .communication-chat__header:after {
                content:'';
                background-image: url('assets/down.png');
                background-size: 100%;
                background-repeat: no-repeat;
                width: 15px;
                height: 15px;
                position: absolute;
                right: 15px;
                top: 5px;
           }
           
            .collapse .communication-chat__header:after {
            background-image: url('assets/up.png');
           
        }
           .communication-chat__footer{
                display: flex;
                background-color: #CDCDCD;
                width: 100%;
                padding-top: 10px;
                padding-bottom: 10px;
                justify-content: space-evenly;
               
           }
           
           .communication-chat__close {
                font-size: 14px;
                text-underline: #7D7D7D;
                display: inline-block;
                text-decoration: none;
                outline: none;
                background-color: transparent;
                border: none;
                height: 20px;
                width: 100px;
                color:#7D7D7D;
           }
           
           .communication-chat__send {
                outline: none;
                text-decoration: none;
                background-color: #5848F4;
                width: 60px;
                height: 20px;
                cursor: pointer;
           }
        .communication-chat {
            display: flex;
            position: relative;
            height: 100%;
          
            background-color: #FFFEFC;
            border-bottom: 1px solid ghostwhite;
            flex: 1 1 auto;
            flex-direction: column;
            bottom: 0;
            transition: bottom 0.2s ease-in-out;
        }
        
        .communication-chat__entries {
            padding: 10px;
            flex: 1 1 auto;
        }
        .communication-chat-enter {
            padding: 10px;
            color: grey;
            width: 100%;
            border: none;
            
        }
        
        .communication-chat-enter:focus {
        outline: none;;
        }
        .communication-chat__input {
             display: flex;
             justify-content: center;
            padding: 10px;
            flex: 0 0 10px;
           
            border-top: 1px solid #CDCDCD;
          
        }
        
      
        </style>
        <div class="communication-chat">
            <div class="communication-chat__header" @click="${this.expandCollapse}"> </div>
            <div class="communication-chat__entries">
                ${this.receivedMessages.map((item) => html `<chat-entry message="${item.message}" user="${item.user}"></chat-entry>`)}
            </div>
            <div class="communication-chat__input">
             <input type="text" 
             @input="${this.updateValue}" 
             @keypress="${this.sendMessage}" 
             placeholder="Enter a text" 
             value="${this.currentMessage}"
             class="communication-chat-enter">
             </div>
             <div class="communication-chat__footer">
                <button class="communication-chat__close" @click="${this.closeChat}">End Chat</button>
                <button type="button" class="communication-chat__send" @click="${this.sendMessage}">Send</button>
            </div>
         </div>
        `;
    }
    initialize() {
        super.initialize();
        // @ts-ignore
        this.database = firebase.database().ref('/messages');
        this.database.on(`child_added`, (data) => {
            // here is where the message is going to be received
            let value = data.val();
            const msg = value.message;
            const sender = value.sender;
            console.log(msg, sender);
            let copy = this.receivedMessages.slice(0);
            copy.push(value);
            this.receivedMessages = copy;
        });
    }
    updateValue(event) {
        this.currentMessage = event.target.value;
    }
    closeChat(event) {
        event.preventDefault();
    }
    sendMessage(event) {
        if (event.code == 'Enter' || !event.code) {
            console.log('sending message');
            var msg = this.database.push({ sender: this.profileId, user: Codellaborate.getUser(), message: this.currentMessage });
            msg.remove();
            this.currentMessage = '';
        }
    }
    expandCollapse(event) {
        const target = event.target;
        const chatContainer = target.parentElement;
        if (chatContainer) {
            chatContainer.classList.toggle('collapse');
            if (chatContainer.classList.contains('collapse')) {
                chatContainer.style.bottom = `-${chatContainer.offsetHeight - 20}px`;
            }
            else {
                chatContainer.style.bottom = `0px`;
            }
        }
    }
};
__decorate([
    property()
], ChatElement.prototype, "name", void 0);
__decorate([
    property({ type: Array })
], ChatElement.prototype, "receivedMessages", void 0);
ChatElement = __decorate([
    customElement('cea-chat')
], ChatElement);
export { ChatElement };
